import { defineStore } from 'pinia';
import state from './state.js';
import getters from './getters.js';
import actions from './actions.js';

const useSharedStore = defineStore('shared', {
	state,
	actions,
	getters,
	persist: true,
});

export default useSharedStore;
